module.exports = __webpack_public_path__ + "img/eleven.8f513dda.png";